/** @format */

import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {Space, WidgetSettingsList} from 'pages/Home/DigitalCast/models/spaces';

import {getCalcMethod} from './getCalcMethod';
import {WIDGETS_LIST} from '../../../constants/widgets';

/**
 * Добавляет высчитанную статистику и прочие настройки виджетов в уже существующее рабочее пространство
 * @param space
 * @param settings
 */

const injectWidgetSettings = (space: Space, settings: WidgetSettingsList): Space => {
  const newSettings: WidgetSettingsList = {};

  const chartIds = Object.keys(settings) as ChartIds[];
  chartIds.forEach(id => {
    const existing = space.widgetsSettings[id];
    // Логика нахождения значений кнопок (типа "сумма-день", "масштаб"):
    // Если кнопка должна быть отрисована, то забираем сохраненное значение
    // Если сохраненного значения нет, то [ключ]: [значение по умолчанию]
    // Если кнопка не должна быть отрисована, то ключ не добавляется
    const isShowScaleButton = WIDGETS_LIST[id]?.showScaleButton;
    const scaleButton = isShowScaleButton
      ? {
          isScaleChecked: Boolean(existing?.isScaleChecked),
        }
      : {};

    const isShowSumDayButton = WIDGETS_LIST[id]?.showSumDayButton;
    const sumDayButton = isShowSumDayButton
      ? {
          calcMethod: getCalcMethod(existing),
        }
      : {};

    newSettings[id] = {
      stats: existing?.stats ?? settings[id]?.stats,
      ...scaleButton,
      ...sumDayButton,
      ...(existing?.custom ? {custom: existing.custom} : {}),
      ...(settings[id]?.hide ? {hide: true} : {}),
    };
  });

  return {
    ...space,
    widgetsSettings: newSettings,
  };
};

export default injectWidgetSettings;
